'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '@/lib/auth/AuthContext';
import { signOutAdminAndRedirect } from '@/lib/auth/adminLogout';
import { supabase, withAuthLockRetry } from '@/lib/supabase/client';
import { useInactivityTimeout } from '@/hooks/useInactivityTimeout';
import { InactivityWarningDialog } from '@/components/auth/InactivityWarningDialog';
import { DEFAULT_INACTIVITY_TIMEOUT, InactivityTimeoutSettings } from '@/types/organization';
export function AgentInactivityGuard() {
  const $ = _c(18);
  const {
    signOut,
    currentOrganization
  } = useAuth();
  const [timeoutConfig, setTimeoutConfig] = useState(DEFAULT_INACTIVITY_TIMEOUT);
  let t0;
  let t1;
  if ($[0] !== currentOrganization) {
    t0 = () => {
      if (!currentOrganization) {
        return;
      }
      const co = currentOrganization as any;
      const targetOrgId = co.parent_org_id ?? co.id;
      if (!targetOrgId) {
        return;
      }
      (supabase as any).from("organizations").select("settings").eq("id", targetOrgId).single().then(t2 => {
        const {
          data
        } = t2;
        const cfg = data?.settings?.features?.agent_inactivity_timeout;
        if (cfg) {
          setTimeoutConfig({
            ...DEFAULT_INACTIVITY_TIMEOUT,
            ...cfg
          });
        }
      }).catch(_temp);
    };
    t1 = [currentOrganization];
    $[0] = currentOrganization;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== signOut) {
    t2 = async () => {
      try {
        await signOutAdminAndRedirect({
          supabase,
          signOut,
          query: "reason=inactivity"
        });
      } catch {
        if (typeof window !== "undefined") {
          window.location.href = "/admin/login?reason=inactivity";
        }
      }
    };
    $[3] = signOut;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const redirectToBrandedLogin = t2;
  const handleTimeout = redirectToBrandedLogin;
  const handleLogout = redirectToBrandedLogin;
  const t3 = timeoutConfig.timeout_minutes * 60 * 1000;
  const t4 = timeoutConfig.warning_before_seconds * 1000;
  let t5;
  if ($[5] !== handleTimeout || $[6] !== t3 || $[7] !== t4 || $[8] !== timeoutConfig.warning_enabled) {
    t5 = {
      timeoutMs: t3,
      warningMs: t4,
      warningEnabled: timeoutConfig.warning_enabled,
      onTimeout: handleTimeout
    };
    $[5] = handleTimeout;
    $[6] = t3;
    $[7] = t4;
    $[8] = timeoutConfig.warning_enabled;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const {
    isWarning,
    secondsRemaining,
    resetTimer
  } = useInactivityTimeout(t5);
  let t6;
  if ($[10] !== redirectToBrandedLogin || $[11] !== resetTimer) {
    t6 = async () => {
      const {
        error
      } = await withAuthLockRetry(_temp2).catch(_temp3);
      if (error) {
        await redirectToBrandedLogin();
        return;
      }
      resetTimer();
    };
    $[10] = redirectToBrandedLogin;
    $[11] = resetTimer;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleStay = t6;
  let t7;
  if ($[13] !== handleLogout || $[14] !== handleStay || $[15] !== isWarning || $[16] !== secondsRemaining) {
    t7 = <InactivityWarningDialog open={isWarning} secondsRemaining={secondsRemaining} onStay={handleStay} onLogout={handleLogout} />;
    $[13] = handleLogout;
    $[14] = handleStay;
    $[15] = isWarning;
    $[16] = secondsRemaining;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
function _temp3() {
  return {
    error: new Error("refresh failed")
  };
}
function _temp2() {
  return supabase.auth.refreshSession();
}
function _temp() {}